import { render } from "./DetailContent.vue?vue&type=template&id=3c2899f4&scoped=true"
import script from "./DetailContent.vue?vue&type=script&lang=js"
export * from "./DetailContent.vue?vue&type=script&lang=js"

import "./DetailContent.vue?vue&type=style&index=0&id=3c2899f4&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2899f4"]])

export default __exports__